import React from 'react';
import { motion } from 'framer-motion';
export function WhyItWorksSection() {
  return <section className="w-full bg-warm-white py-16 px-6 md:py-24" data-id="element-260">
      <div className="max-w-reading mx-auto" data-id="element-261">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-262">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-6 font-serif text-center" data-id="element-263">
            Why it works (when "random rules" don't)
          </h2>
          <p className="text-xl text-charcoal/80 mb-12 text-center" data-id="element-264">
            Because it's not based on motivation. It's based on pattern
            detection.
          </p>

          <p className="text-lg font-bold text-charcoal mb-8 uppercase tracking-wide text-center" data-id="element-265">
            Instead of "try harder," you're doing:
          </p>

          <div className="space-y-6 max-w-lg mx-auto" data-id="element-266">
            {['Track the three drivers', 'Adjust one lever at a time', 'Keep what improves your One Full Block (OFB)', "Drop what doesn't"].map((step, index) => <div key={index} className="flex items-center gap-4 p-4 bg-white/50 rounded-lg border-l-4 border-sage" data-id="element-267">
                <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-sage/10 text-sage-dark font-bold font-serif" data-id="element-268">
                  {index + 1}
                </span>
                <span className="text-xl text-charcoal font-medium" data-id="element-269">
                  {step}
                </span>
              </div>)}
          </div>

          <p className="mt-12 text-xl md:text-2xl font-serif italic text-charcoal text-center" data-id="element-270">
            That's how you get results without turning your evenings into a
            stress ritual.
          </p>
        </motion.div>
      </div>
    </section>;
}